import { Helmet } from 'react-helmet-async';
import  { useState, useEffect } from 'react';

// Page title component for globally handle the title
const PageTitle = (props) => {
  const [pageTitle, setPageTitle] = useState('');
  const tagLine = 'TechForGov';

  // Hook to get the title and set it
  useEffect(() => {
    setPageTitle(props.title);
  }, [props.title]);

  return (
    <>
      <Helmet>
        <title>
          {pageTitle && pageTitle + ' | '} {tagLine}
        </title>
      </Helmet>
    </>
  );
};

export default PageTitle;
